export default __webpack_public_path__ + "static/hhc-blog-2-8cdc215d59f10c838ef440d109724b31.png";